var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("h1", { staticClass: "text-center bot-color-blue" }, [
        _vm._v("Quản lý dự án SEO"),
      ]),
      _c(
        "div",
        { staticClass: "text-center mt-2" },
        [
          _c(
            "v-btn",
            { attrs: { color: "primary" }, on: { click: _vm.addProject } },
            [
              _vm._v("\n            Thêm dự án\n            "),
              _c("v-icon", { attrs: { right: "" } }, [
                _vm._v(" mdi-plus-circle "),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        _vm._l(_vm.projectList, function (prj, p) {
          return _c(
            "v-col",
            {
              key: p,
              class: _vm.projectList.length === 1 ? "bot-center" : "",
              attrs: {
                cols: "12",
                xs: "12",
                sm: "6",
                md: "4",
                lg: "3",
                xl: "3",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(`${prj.No}. ${prj.ProjectTitle}`) +
                        "\n                "
                    ),
                  ]),
                  _c("v-card-text", [
                    _c("table", { staticClass: "bot-table" }, [
                      _c("tbody", [
                        _c("tr", [
                          _c("th", [_vm._v("Host:")]),
                          _c("td", [_vm._v(_vm._s(prj.ProjectHost))]),
                        ]),
                        _c("tr", [
                          _c("th", [_vm._v("Từ khóa:")]),
                          _c("td", [
                            _c("a", { attrs: { href: prj.LinkRanking } }, [
                              _vm._v("Chi tiết"),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            text: "",
                            href: `/project/detail/${prj.ProjectID}`,
                          },
                        },
                        [
                          _vm._v(
                            "\n                        Chi tiết\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
      _c("project-item", {
        model: {
          value: _vm.selectedItem,
          callback: function ($$v) {
            _vm.selectedItem = $$v
          },
          expression: "selectedItem",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/views/project/project.list.vue